import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71db8723"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-content-wrapper" }
const _hoisted_2 = { class: "tab-content" }
const _hoisted_3 = { class: "row-fields-4" }
const _hoisted_4 = { class: "row-fields-4" }
const _hoisted_5 = { class: "row-fields-4" }
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "row-fields-4" }
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "row-fields-4" }
const _hoisted_10 = { class: "row-fields-4" }
const _hoisted_11 = { class: "datebox" }
const _hoisted_12 = { class: "datebox" }
const _hoisted_13 = { class: "tab-content" }
const _hoisted_14 = { class: "tab-content" }
const _hoisted_15 = { class: "tab-content" }
const _hoisted_16 = { class: "tab-content" }

import moment from "moment";
import { computed, inject, onMounted, ref, watch } from "vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import PropertyLookup from "@/components/ui/lookup/property-lookup.vue";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import { PreTenancyItem } from "@/types/tenancies/PreTenancyItem";
import { SetupFee } from "@/types/tenancies/PreTenancyItem";
import { TenanciesValidation } from "acquaint-api/validation/TenanciesValidation";
import { BankAccountsValidation } from "acquaint-api/validation/BankAccountsValidation";
import AcquaintDateBox from "@/components/ui/inputs/acquaint-date-box.vue";
import NumberDropdown from "@/components/ui/dropdowns/number-dropdown.vue";
import SingleSelect from "@/components/ui/dropdowns/single-select.vue";
import CurrencyInfoBox from "@/components/ui/inputs/currency-info-box.vue";
import CurrencyInput from "@/components/ui/inputs/currency-input.vue";
import { CodeType } from "acquaint-api/constants/CodeType";
import { IDDescriptionPair } from "@/types/generic/IDDescriptionPair";
import SystemCodeSingleSelect from "@/components/ui/system-codes/system-code-single-select.vue";
import { PaymentMethod } from "@/enums/tenancies/PaymentMethod";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import { TenancyHelper } from "@/utils/tenancies/TenancyHelper";
import AcquaintTextArea from "@/components/ui/inputs/acquaint-text-area.vue";
import { ValidatedEvent } from "devextreme/ui/validator";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { OfferPropertyItem } from "@/types/tenancies/OfferPropertyItem";
import { OfferContactItem } from "@/types/tenancies/OfferContactItem";
import { Properties } from "acquaint-api/models/Properties";
import { PaymentFrequency } from "@/enums/tenancies/PaymentFrequency";
import { PriceFrequency } from "@/enums/tenancies/PriceFrequency";
import { TenancyInterval } from "@/enums/tenancies/TenancyInterval";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import LookupSingleSelect from "@/components/ui/lookup/lookup-single-select.vue";
import { LookupTableSource } from "acquaint-api/constants/LookupTableSource";
import { MaxDepositItem } from "@/types/tenancies/MaxDepositItem";
import { DailyRentAmountItem } from "@/types/tenancies/DailyRentAmountItem";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { SetupFeeInfo } from "@/types/tenancies/SetupFeeInfo";
import { ExistingTenancyInfo } from "@/types/tenancies/ExistingTenancyInfo";
import { TenancyStatus } from "@/enums/tenancies/TenancyStatus";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { BankAccountInfo } from "@/types/tenancies/BankAccountInfo";
import { formatNumberIntoCurrency } from "@/utils/CurrencyFormatter";
import { DeductHoldingDepositFrom } from "@/enums/tenancies/DeductHoldingDepositFrom";
import { SetupFeeGridItem } from "@/types/tenancies/SetupFeeGridItem";
import SetupFeeGrid from "@/components/tenancies/pre-tenancies/setup-fee-grid.vue";
import { PreTenancyCreatedItem } from "@/types/tenancies/PreTenancyCreatedItem";
import { FieldSize } from "@/enums/system/FieldSize";
import { displayQuestionAlert } from "@/alerts/questionAlert";
import { DepositLegalMaxRequest } from "@/types/tenancies/DepositLegalMaxRequest";
import { ExistingPrepayment } from "@/types/tenancies/ExistingPrepayment";
import TenantsGuarantors from "@/components/tenancies/pre-tenancies/tenants-guarantors.vue";
import PermittedOccupiers from "@/components/tenancies/pre-tenancies/permitted-occupiers.vue";
import { ContactFindTypeRestriction } from "@/enums/contacts/ContactFindTypeRestriction";
import { PropertyCategory } from "acquaint-api/constants/PropertyCategory";
import ContactModal from "@/components/contacts/record/contact-modal.vue";
import { Contacts } from "acquaint-api/models/Contacts";
import { useContactHelper } from "@/utils/contacts/useContactHelper";
import { PropertyStatus } from "acquaint-api/constants/PropertyStatus";


export default /*#__PURE__*/_defineComponent({
  __name: 'pre-tenancy-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },
  /** Id of the contact
   * @type {number}
   * @default: 0
   */
  contactId: {
    type: Number,
    default: 0,
  },
  /** Id of the property
   * @type {number}
   * @default: 0
   */
  propertyId: {
    type: Number,
    default: 0,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when the modal is closed.
   */
  "modalClosed",
  /**
   * Triggered when the details are successfully saved.
   */
  "detailsSaved",
],
  setup(__props, { emit }) {

const props = __props;





onMounted(async () => {
  currentUserDetails.value = await currentUserStore.getCurrentUserDetails();
});

const acquaintApiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const acquaintNextApiClient = inject(
  "AcquaintApiNextClient",
) as AcquaintApiNextClient;

const screenSize = ref(screen.width);
const autoNumber = ref(0);
const initialPermittedFormData = ref(false);
const currentUserStore = useCurrentUserStore();
const currentUserDetails = ref<CurrentUser>();
const systemConfigurationStore = useSystemConfigurationStore();

const getDefaultDuration = async () => {
  var duration = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.DefaultMinimumTenancyTerm,
  );

  return parseInt(duration);
};
const getPreTenancyReceivingPayment = async () => {
  var result = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.PreTenancyReceivingPayment,
  );
  return result;
};

const getDefaultManagementTypeID = async () => {
  var result = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.DefaultManagementTypeID,
  );
  return parseInt(result);
};

const getTenantFee1Product = async () => {
  var result = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.TenantFee1Product,
  );
  return parseInt(result);
};

const getTenantFee2Product = async () => {
  var result = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.TenantFee2Product,
  );
  return parseInt(result);
};

const getTenantFee3Product = async () => {
  var result = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.TenantFee3Product,
  );
  return parseInt(result);
};

const getDepositHeld = async () => {
  var result = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.DepositHeld,
  );

  return parseInt(result);
};

const { fetchContactById } = useContactHelper();
const propertiesData = ref<Properties>();
const selectedTab = ref(0);
const displayCloseConfirmationPrompt = ref(false);
const keepingModalOpening = ref(false);
const previousRentAmount = ref(0);
const setupFeeTotal = ref(0);
const maxDeposit = ref(0);
const maxHoldingDeposit = ref(0);
const mdecExistingDepositFound = ref(0);
const mdecOriginalRentAmount = ref(0);
const mdecDailyRentAmount = ref(0);
const maxHoldingDepositInfo = ref("");
const mbytPreviousInterval = ref(0);
const setupFees = ref<SetupFee[]>([]);
const displayNewContactModal = ref(false);

const setupFeeGridItems = ref<SetupFeeGridItem[]>([]);
const initialDefaultPreTenancyItem = (): PreTenancyItem => ({
  propertyId: 0,
  contactId: 0,
  startDate: moment().format("YYYY-MM-DD"),
  endDate: "",
  interval: 0,
  duration: 0,
  managementTypeId: 0,
  rent: 0,
  rentPaymentFrequency: 0,
  rentPaymentDay: 0,
  deposit: 0,
  depositHeldBy: 0,
  bankAccountId: 0,
  receivingPayment: false,
  paymentReceivedDate: "",
  paymentReceivedMethod: 0,
  paymentReceivedByUserId: 0,
  setupFees: [],
  holdingDeposit: 0,
  deductHoldingDepositFrom: 0,
  upfrontRent: 0,
  notes: "",
});
const preTenancyData = ref<PreTenancyItem>(initialDefaultPreTenancyItem());
const preTenancyCreatedItem = ref<PreTenancyCreatedItem>();
const originalPreTenancyData = ref<PreTenancyItem>(
  initialDefaultPreTenancyItem(),
);
const permittedOccupierscontactIds = ref<number[]>([]);

const paymentMethods: IDDescriptionPair[] = Object.entries(PaymentMethod)
  .filter(([, value]) => typeof value === "number")
  .map(([key, value]) => ({
    id: value as number,
    description: TenancyHelper.camelToTitleCase(key),
  }));

const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const fetchOfferContactItem = async (
  propertyId: number,
): Promise<OfferContactItem> => {
  try {
    const contactOffer = await acquaintApiClient.httpGet<OfferContactItem>(
      `app/tenancy/offer/${propertyId}/property`,
    );
    preTenancyData.value.propertyId = propertyId;
    preTenancyData.value.contactId = contactOffer.contactId;
    preTenancyData.value.rent = contactOffer.amount;
    preTenancyData.value.notes = contactOffer.notes;
    previousRentAmount.value = preTenancyData.value.rent;
    await fetchPropertiesData(propertyId);
    return contactOffer;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return null!;
  }
};

const moveDetailsToForm = async (decPassedRent: number) => {
  await initialFormData();

  const tenantFee1Product = await getTenantFee1Product();
  const setupFeeInfo1 = await fetchSetupFeeInfo(tenantFee1Product);
  if (setupFeeInfo1) {
    addSetupFees(setupFeeInfo1);
  }
  await getTenantFee2Product();

  const tenantFee2Product = await getTenantFee2Product();
  var setupFeeInfo2 = await fetchSetupFeeInfo(tenantFee2Product);
  if (setupFeeInfo2) {
    addSetupFees(setupFeeInfo2);
  }

  const tenantFee3Product = await getTenantFee3Product();
  var setupFeeInfo3 = await fetchSetupFeeInfo(tenantFee3Product);
  if (setupFeeInfo3) {
    addSetupFees(setupFeeInfo3);
  }
  preTenancyData.value.paymentReceivedDate = moment().format("YYYY-MM-DD");
  preTenancyData.value.paymentReceivedMethod = PaymentMethod.Cash;
  preTenancyData.value.receivingPayment =
    (await getPreTenancyReceivingPayment()) == "1" ? true : false;

  await loadPropertyInfo(decPassedRent);

  await fetchMaxHoldingAndDepositData();

  if (
    preTenancyData.value?.propertyId > 0 &&
    preTenancyData.value.contactId > 0
  ) {
    await loadTenancy(
      preTenancyData.value?.propertyId,
      preTenancyData.value.contactId,
    );
  }

  originalPreTenancyData.value = JSON.parse(
    JSON.stringify(preTenancyData.value),
  );
};

const initialFormData = async () => {
  preTenancyData.value.duration = await getDefaultDuration();
  preTenancyData.value.endDate = await adjustEndDate(
    preTenancyData.value.startDate,
    preTenancyData.value.interval,
    preTenancyData.value.duration,
  );
  preTenancyData.value.paymentReceivedByUserId =
    currentUserDetails.value?.id ?? 0;

  const now = new Date();
  preTenancyData.value.rentPaymentDay = now.getDate();
  preTenancyData.value.depositHeldBy = await getDepositHeld();
};

watch(
  () => showModal.value,
  async () => {
    if (keepingModalOpening.value || !showModal.value) {
      return;
    }

    initialPermittedFormData.value = true;
    autoNumber.value = moment().unix();
    propertiesData.value = undefined;
    preTenancyData.value = {
      ...preTenancyData.value,
      ...initialDefaultPreTenancyItem(),
    };
    previousRentAmount.value = 0;
    maxDeposit.value = 0;
    maxHoldingDeposit.value = 0;
    mdecExistingDepositFound.value = 0;
    mdecOriginalRentAmount.value = 0;
    mdecDailyRentAmount.value = 0;

    maxHoldingDepositInfo.value = "";
    preTenancyData.value.deductHoldingDepositFrom =
      DeductHoldingDepositFrom.Deposit;

    selectedTab.value = 0;
    displayCloseConfirmationPrompt.value = false;

    if (props.propertyId <= 0 && props.contactId > 0) {
      await fetchOfferPropertyItem(props.contactId);
      preTenancyData.value.contactId = props.contactId;
    }

    if (props.propertyId > 0 && props.contactId <= 0) {
      await fetchOfferContactItem(props.propertyId);
      preTenancyData.value.propertyId = props.propertyId;
    }
    await moveDetailsToForm(preTenancyData.value.rent);
  },
  { immediate: true },
);

watch(
  [() => preTenancyData.value, () => originalPreTenancyData.value],
  ([newWorkOrder, newOriginal]) => {
    if (JSON.stringify(newOriginal) === JSON.stringify(newWorkOrder)) {
      displayCloseConfirmationPrompt.value = false;
    } else {
      displayCloseConfirmationPrompt.value =
        JSON.stringify(newWorkOrder) !== JSON.stringify(newOriginal);
    }
  },
  { deep: true },
);

const loadTenancy = async (propertyId: number, contactId: number) => {
  if (!(propertyId > 0 && contactId > 0)) return;

  const tenancyInfo = await checkExistingTenancy(propertyId, contactId);

  if (tenancyInfo) {
    const checkPreTenancySatusFlag = await checkPreTenancySatus(
      tenancyInfo.tenancyStatus,
    );

    if (!checkPreTenancySatusFlag) {
      await standardInfoAlert(
        "A Pre-Tenancy has already been started for this Property and Contact.",
      );
      displayCloseConfirmationPrompt.value = false;
      showModal.value = false;
      return;
    } else {
      const sendConfirmationAlert = await displayQuestionAlert(
        "A Tenancy is already in place for this Property and Contact. Are you sure you would like to continue adding this Pre-Tenancy?",
      );

      if (!sendConfirmationAlert.isConfirmed) {
        displayCloseConfirmationPrompt.value = false;
        showModal.value = false;
        return;
      }
    }
  }
};

const checkPreTenancySatus = (tenancyStatus: number) => {
  if (tenancyStatus != TenancyStatus.PreTenancy) return false;
  if (propertiesData.value?.status == PropertyStatus.Available) return true;
  if (propertiesData.value?.status == PropertyStatus.Instructed) return true;
  return false;
};

const addSetupFees = (setupFeeInfo: SetupFeeInfo) => {
  if (setupFeeInfo) {
    var setupFee: SetupFee = {
      amount: setupFeeInfo.defaultAmount,
      productId: setupFeeInfo.productId,
      taxRateId: setupFeeInfo.taxRateId,
      taxRate: setupFeeInfo.taxRate,
    };
    preTenancyData.value.setupFees.push(setupFee);
    upsertSetupFeeInfo(setupFeeInfo);
  }
};

const upsertSetupFeeInfo = (newInfo: SetupFeeInfo) => {
  const vat =
    Math.round(
      (newInfo.defaultAmount / (100 + newInfo.taxRate)) * newInfo.taxRate * 100,
    ) / 100;
  const net =
    Math.round((newInfo.defaultAmount / (100 + newInfo.taxRate)) * 100 * 100) /
    100;

  const gross = vat + net;

  // Create grid item
  const gridItem: SetupFeeGridItem = {
    ...newInfo,
    net,
    vat,
    gross,
  };

  // Upsert into grid items
  const indexGrid = setupFeeGridItems.value.findIndex(
    (item) => item.productId === newInfo.productId,
  );
  if (indexGrid !== -1) {
    // Update existing item
    setupFeeGridItems.value[indexGrid] = gridItem;
  } else {
    // Add new item
    setupFeeGridItems.value.push(gridItem);
  }

  setupFeeGridItems.value = [...setupFeeGridItems.value];
};

const fetchSetupFeeInfo = async (
  productId: number,
): Promise<SetupFeeInfo | undefined> => {
  try {
    if (productId <= 0) return undefined;

    const setupFee = await acquaintNextApiClient.httpGet<SetupFeeInfo>(
      `/tenancies/${productId}/Product/SetupFee`,
    );
    return setupFee;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return undefined;
  }
};

const readExistingPrePayments = async (
  propertyId: number,
  contactId: number,
) => {
  // propertyId > 0 && contactId > 0
  if (!(propertyId > 0 && contactId > 0)) return;

  const existingPrepayment = await fetchExistingPrepayments(
    propertyId,
    contactId,
  );
  if (existingPrepayment) {
    mdecExistingDepositFound.value = existingPrepayment.existingDepositAmount;
  }
  updateHoldingDepositInfo();
};

const fetchExistingPrepayments = async (
  propertyId: number,
  contactId: number,
): Promise<ExistingPrepayment | undefined> => {
  try {
    if (!(propertyId > 0 && contactId > 0)) return;

    const item = await acquaintApiClient.httpGet<ExistingPrepayment>(
      `app/tenancy/${propertyId}/property/${contactId}/contact/existingprepayments`,
    );
    return item;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return undefined;
  }
};

const checkExistingTenancy = async (
  propertyId: number,
  contactId: number,
): Promise<ExistingTenancyInfo | undefined> => {
  try {
    const tenancyInfo =
      await acquaintNextApiClient.httpGet<ExistingTenancyInfo>(
        `/tenancies/${propertyId}/Property/${contactId}/Contact/CheckExistingTenancy`,
      );
    return tenancyInfo;
  } catch (err) {
    return undefined;
  }
};

const adjustEndDate = async (
  startDate: string,
  interval: number,
  duration: number,
): Promise<string> => {
  try {
    const endDate = await acquaintApiClient.httpPost<string>(
      `app/tenancy/adjustenddate`,
      {
        startDate: startDate,
        interval: interval,
        duration: duration - 1,
      },
    );

    if (interval === TenancyInterval.Days) {
      updateDailyRentAmount();
    }

    const date = new Date(preTenancyData.value.startDate);
    preTenancyData.value.rentPaymentDay = date.getDate();
    return endDate;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return "";
  }
};

const updateDailyRentAmount = () => {
  preTenancyData.value.rent =
    mdecDailyRentAmount.value * (preTenancyData.value.duration + 1);
  previousRentAmount.value = preTenancyData.value.rent;
};

const fetchOfferPropertyItem = async (
  contactId: number,
): Promise<OfferPropertyItem> => {
  try {
    const propertyOffer = await acquaintApiClient.httpGet<OfferPropertyItem>(
      `app/tenancy/offer/${contactId}/contact`,
    );
    preTenancyData.value.contactId = contactId;
    preTenancyData.value.propertyId = propertyOffer.propertyId;
    preTenancyData.value.rent = propertyOffer.amount;
    previousRentAmount.value = preTenancyData.value.rent;
    preTenancyData.value.notes = propertyOffer.notes;
    await fetchPropertiesData(propertyOffer.propertyId);
    return propertyOffer;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return null!;
  }
};

const fetchPropertiesData = async (propertyId: number) => {
  try {
    propertiesData.value = await acquaintApiClient.httpGet(
      `database/properties/${propertyId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const depositInfo = computed(() => {
  if (maxDeposit.value > 0 && currentUserDetails.value) {
    return `(Max deposit: ${formatNumberIntoCurrency(
      maxDeposit.value,
      currentUserDetails.value.countryCodeID,
    )})`;
  } else {
    return "";
  }
});

const fetchMaxHoldingAndDepositData = async () => {
  try {
    if (!propertiesData.value) return;

    const request = {
      rent: preTenancyData.value.rent,
      propertyUsage: propertiesData.value?.usage,
      propertyCountryCode: propertiesData.value?.countryCode,
      tenancyStartDate: preTenancyData.value.startDate,
      tenancyPaymentFrequency: preTenancyData.value.rentPaymentFrequency,
    };
    const item = await acquaintApiClient.httpPost<MaxDepositItem>(
      `app/tenancy/maxdeposit`,
      request,
    );
    maxDeposit.value = item.maxDeposit;
    maxHoldingDeposit.value = item.maxHoldingDeposit;

    preTenancyData.value.holdingDeposit = maxHoldingDeposit.value;

    if (preTenancyData.value.rent === propertiesData.value?.price) {
      preTenancyData.value.deposit = propertiesData.value.deposit;
    } else {
      preTenancyData.value.deposit = maxDeposit.value;
    }

    updateHoldingDepositInfo();
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const updateHoldingDepositInfo = () => {
  if (!currentUserDetails.value) return "";

  maxHoldingDepositInfo.value = "";
  if (maxHoldingDeposit.value > 0) {
    maxHoldingDepositInfo.value = `Max holding deposit: ${formatNumberIntoCurrency(
      maxHoldingDeposit.value,
      currentUserDetails.value.countryCodeID,
    )}`;
  }

  if (mdecExistingDepositFound.value > 0) {
    maxHoldingDepositInfo.value = `${maxHoldingDepositInfo.value}. Already received ${formatNumberIntoCurrency(
      mdecExistingDepositFound.value,
      currentUserDetails.value.countryCodeID,
    )}`;
  }

  if (maxHoldingDepositInfo.value) {
    maxHoldingDepositInfo.value = `(${maxHoldingDepositInfo.value})`;
  }
};

const fetchDailyRentAmountData = async () => {
  try {
    const request = {
      rentAmount: preTenancyData.value.rent,
      propertyUsage: propertiesData.value?.priceFrequency,
    };
    const item = await acquaintApiClient.httpPost<DailyRentAmountItem>(
      `app/tenancy/dailyrentamount`,
      request,
    );
    return item.dailyRentAmount;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

const loadPropertyInfo = async (decPassedRent: number = 0) => {
  let decPrice = 0;
  if (decPassedRent > 0) {
    decPrice = decPassedRent;
  } else {
    decPrice = propertiesData.value?.price ?? 0;
  }

  if (propertiesData.value?.managementTypeID === 0) {
    preTenancyData.value.managementTypeId = await getDefaultManagementTypeID();
  } else {
    preTenancyData.value.managementTypeId =
      propertiesData.value?.managementTypeID ??
      (await getDefaultManagementTypeID());
  }

  preTenancyData.value.rent = decPrice;
  previousRentAmount.value = preTenancyData.value.rent;

  mdecOriginalRentAmount.value = decPrice;
  mdecDailyRentAmount.value = (await fetchDailyRentAmountData()) ?? 0;

  const backAccountInfo = await setBankAccountLookup(
    preTenancyData.value.propertyId,
    propertiesData.value?.companyID,
  );

  if (backAccountInfo) {
    preTenancyData.value.bankAccountId = backAccountInfo.bankAccountId;
  }

  await readExistingPrePayments(
    preTenancyData.value.propertyId,
    preTenancyData.value.contactId,
  );

  if (propertiesData.value && propertiesData.value?.rentalMinimumTerm > 0) {
    preTenancyData.value.duration = propertiesData.value.rentalMinimumTerm;
  } else {
    preTenancyData.value.duration = await getDefaultDuration();
  }

  setPaymentFrequency();
};

const setBankAccountLookup = async (
  propertyId: number = 0,
  companyId: number = 0,
  currentBankAccountId: number = 0,
  syncBankAccount: boolean = true,
  bypassCompanyCheck: boolean = false,
  contactId: number = 0,
  ignoreBlockCompany: boolean = false,
): Promise<BankAccountInfo | undefined> => {
  try {
    const request = {
      propertyId: propertyId,
      companyId: companyId,
      syncBankAccount: syncBankAccount,
      bypassCompanyCheck: bypassCompanyCheck,
      contactId: contactId,
      ignoreBlockCompany: ignoreBlockCompany,
      currentBankAccountId: currentBankAccountId,
    };
    const item = await acquaintApiClient.httpPost<BankAccountInfo>(
      `app/bankaccounts/lookup`,
      request,
    );
    return item;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return undefined;
  }
};

const handlePropertySelect = async () => {
  await fetchPropertiesData(preTenancyData.value.propertyId);
  await loadPropertyInfo();
  await loadTenancy(
    preTenancyData.value.propertyId,
    preTenancyData.value.contactId,
  );
  await fetchMaxHoldingAndDepositData();
};

const handleContactSelect = async () => {
  await loadTenancy(
    preTenancyData.value.propertyId,
    preTenancyData.value.contactId,
  );

  await readExistingPrePayments(
    preTenancyData.value.propertyId,
    preTenancyData.value.contactId,
  );
  autoNumber.value = moment().unix();
};

const handleRentChanged = async () => {
  if (previousRentAmount.value !== preTenancyData.value.rent) {
    await fetchMaxHoldingAndDepositData();
    previousRentAmount.value = preTenancyData.value.rent;
  }
};

const handlePaymentFrequencyChanged = async () => {
  await fetchMaxHoldingAndDepositData();
};
const setPaymentFrequency = () => {
  if (propertiesData.value) {
    switch (propertiesData.value.priceFrequency) {
      case PriceFrequency.PA:
        preTenancyData.value.rentPaymentFrequency = PaymentFrequency.Yearly;
        break;
      case PriceFrequency.PCM:
        preTenancyData.value.rentPaymentFrequency = PaymentFrequency.Monthly;
        break;
      case PriceFrequency.PQ:
        preTenancyData.value.rentPaymentFrequency =
          PaymentFrequency.QuarterYearly;
        break;
      case PriceFrequency.PW:
      case PriceFrequency.PPPW:
        preTenancyData.value.rentPaymentFrequency = PaymentFrequency.Weekly;
        break;
      case PriceFrequency.PN:
        preTenancyData.value.rentPaymentFrequency = PaymentFrequency.Weekly;
        preTenancyData.value.interval = TenancyInterval.Days;
        updateDailyRentAmount();
        break;
      default:
        preTenancyData.value.rentPaymentFrequency = PaymentFrequency.Monthly;
        break;
    }
  }
};

const handleStartDate = async () => {
  var endDate = await adjustEndDate(
    preTenancyData.value.startDate,
    preTenancyData.value.interval,
    preTenancyData.value.duration,
  );
  preTenancyData.value.endDate = endDate;

  await fetchMaxHoldingAndDepositData();
};

const handleInterval = async () => {
  var endDate = await adjustEndDate(
    preTenancyData.value.startDate,
    preTenancyData.value.interval,
    preTenancyData.value.duration,
  );
  preTenancyData.value.endDate = endDate;

  if (
    preTenancyData.value.interval === TenancyInterval.Days &&
    mbytPreviousInterval.value === TenancyInterval.Days
  ) {
    preTenancyData.value.rent = mdecOriginalRentAmount.value;
  }

  mbytPreviousInterval.value = preTenancyData.value.interval;
};

const handleEndDate = async () => {
  var endDate = await adjustEndDate(
    preTenancyData.value.startDate,
    preTenancyData.value.interval,
    preTenancyData.value.duration,
  );
  preTenancyData.value.endDate = endDate;
};

const handleUpfrontRent = () => {
  if (preTenancyData.value.upfrontRent > 0) {
    preTenancyData.value.receivingPayment = true;
  }
};

const totalDueAmount = computed(() => {
  return (
    setupFeeTotal.value +
    (preTenancyData.value?.holdingDeposit ?? 0) +
    (preTenancyData.value?.upfrontRent ?? 0)
  );
});

const isUpfrontRentReceived = computed(() => {
  return preTenancyData.value.upfrontRent > 0;
});

const enableButttonStates = computed(() => {
  return (
    preTenancyData.value.propertyId > 0 && preTenancyData.value.contactId > 0
  );
});

const saveDetails = async (e: any) => {
  if (!propertiesData.value) return;

  const validation: ValidatedEvent = e.validationGroup.validate();

  // Don't continue if user has entered invalid data
  if (!validation.isValid) {
    return;
  }

  // Don't continue if holding deposit is above deposit amount if using holding deposit for deposit
  if (!checkDepositAmounts()) {
    return;
  }

  // Don't allow users to untick receive holding deposit if it's being used to pay against rent
  if (
    preTenancyData.value.holdingDeposit > 0 &&
    !preTenancyData.value.receivingPayment &&
    preTenancyData.value.deductHoldingDepositFrom ===
      DeductHoldingDepositFrom.Rent
  ) {
    standardInfoAlert(
      "Sorry, it's not possible to charge for the Holding Deposit and deduct it from the Rent. Please either receive the Holding Deposit now or change the Holding Deposit to be deducted from the Deposit.",
    );
    return;
  }

  let request: DepositLegalMaxRequest = {
    deposit:
      preTenancyData.value.holdingDeposit + mdecExistingDepositFound.value,
    rent: preTenancyData.value.rent,
    paymentFrequency: preTenancyData.value.rentPaymentFrequency,
    propertyUsage: propertiesData.value.usage,
    propertyCountryCode: propertiesData.value.countryCode,
    tenancyStartDate: preTenancyData.value.startDate,
    isHoldingDeposit: true,
  };

  // This check is not required if the maximum holding deposit is 0.
  if (preTenancyData.value.holdingDeposit > 0) {
    // Holding deposit can't be more than 1 week's rent
    if (await checkDepositOverLegalMax(request)) {
      const sendConfirmationAlert = await displayQuestionAlert(
        "The holding deposit is more than 1 week's rent. Are you sure you want to continue?",
      );

      if (!sendConfirmationAlert.isConfirmed) {
        return;
      }
    }
  }

  request = {
    ...request,
    deposit: preTenancyData.value.deposit,
    isHoldingDeposit: false,
  };

  // This check is not required if the maximum deposit is 0.
  if (preTenancyData.value.deposit > 0) {
    // If deposit is over legal limit display prompt
    if (await checkDepositOverLegalMax(request)) {
      const sendConfirmationAlert = await displayQuestionAlert(
        "The deposit amount is above the legal maximum deposit. Are you sure you want to continue?",
      );

      if (!sendConfirmationAlert.isConfirmed) {
        return;
      }
    }
  }

  preTenancyData.value.setupFees = [...setupFees.value];

  await createPreTenancy();

  // createPreTenancy failure,  return
  if (!preTenancyCreatedItem.value) return;

  if (permittedOccupierscontactIds.value.length > 0) {
    await savePermittedOccupiers(
      preTenancyCreatedItem.value.tenancyId,
      permittedOccupierscontactIds.value,
    );
  }

  if (preTenancyCreatedItem.value.receiptId > 0) {
    const sendConfirmationAlert = await displayQuestionAlert(
      "Would you like to print a Receipt now for these payments?",
    );

    if (sendConfirmationAlert.isConfirmed) {
      await downloadReceiptPDF(preTenancyCreatedItem.value.receiptId);
    }
  }

  if (preTenancyCreatedItem.value.invoiceId > 0) {
    const sendConfirmationAlert = await displayQuestionAlert(
      "Would you like to print the Invoice now?",
    );

    if (sendConfirmationAlert.isConfirmed) {
      await downloadInvoicePDF(
        propertiesData.value.companyID,
        preTenancyCreatedItem.value.invoiceId,
      );
    }
  }
  displayCloseConfirmationPrompt.value = false;
  showModal.value = false;
  emit("detailsSaved");
};

const checkDepositOverLegalMax = async (request: DepositLegalMaxRequest) => {
  try {
    const isAllowed = await acquaintApiClient.httpPost<boolean>(
      `app/tenancy/depositoverlegalmax`,
      request,
    );
    return isAllowed;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const createPreTenancy = async () => {
  try {
    preTenancyCreatedItem.value =
      await acquaintApiClient.httpPost<PreTenancyCreatedItem>(
        `app/tenancy/createpretenancy`,
        preTenancyData.value,
      );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    preTenancyCreatedItem.value = undefined;
  }
};

const savePermittedOccupiers = async (
  tenancyId: number,
  contactIds: number[],
): Promise<boolean> => {
  try {
    if (tenancyId <= 0) return false;

    await acquaintApiClient.httpPost(
      `app/tenancy/${tenancyId}/permittedoccupiers`,
      contactIds,
    );
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const checkDepositAmounts = () => {
  if (
    preTenancyData.value.holdingDeposit > preTenancyData.value.deposit &&
    preTenancyData.value.deductHoldingDepositFrom ===
      DeductHoldingDepositFrom.Deposit
  ) {
    standardInfoAlert(
      "The Holding Deposit cannot be greater then the Deposit.",
    );
    return false;
  }
  return true;
};

const fetchReceiptPDF = async (
  receiptId: number,
): Promise<Blob | undefined> => {
  try {
    return await acquaintApiClient.getFile(
      `app/tenancy/${receiptId}/receiptpdf`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return undefined;
  }
};
const downloadReceiptPDF = async (receiptId: number) => {
  let pdf: Blob | undefined;
  pdf = await fetchReceiptPDF(receiptId);

  if (!pdf) {
    return;
  }

  // Create url
  const url = window.URL.createObjectURL(pdf);

  // Link allows us to download the pdf
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `pre-tenancy-${receiptId}-receipt.pdf`);
  document.body.appendChild(link);
  link.click();

  // Clears memory
  link.remove();
  window.URL.revokeObjectURL(url);
};

const fetchInvoicePDF = async (
  companyId: number,
  invoiceId: number,
): Promise<Blob | undefined> => {
  try {
    return await acquaintApiClient.getFile(
      `app/tenancy/${companyId}/company/${invoiceId}/invoicepdf`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return undefined;
  }
};

const downloadInvoicePDF = async (companyId: number, invoiceId: number) => {
  let pdf: Blob | undefined;
  pdf = await fetchInvoicePDF(companyId, invoiceId);

  if (!pdf) {
    return;
  }

  // Create url
  const url = window.URL.createObjectURL(pdf);

  // Link allows us to download the pdf
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `pre-tenancy-${invoiceId}-invoice.pdf`);
  document.body.appendChild(link);
  link.click();

  // Clears memory
  link.remove();
  window.URL.revokeObjectURL(url);
};

const keepEnteredInformation = () => {
  keepingModalOpening.value = true;
};

const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const closeModal = () => {
  displayCloseConfirmationPrompt.value = false;
};

const modalClosed = async () => {
  closeModal();
  keepingModalOpening.value = false;
  emit("modalClosed");
};

const cancelClick = () => {
  showModal.value = false;
};

const onPermittedInitialOpened = () => {
  initialPermittedFormData.value = false;
};
const onPermittedUpdateContactIds = (ids: number[]) => {
  permittedOccupierscontactIds.value = ids;
};

const tenantFieldRequired = computed(() => {
  return !preTenancyData.value.contactId;
});
const openNewContactModal = () => {
  displayNewContactModal.value = true;
};

const contactCreated = async (id: number) => {
  const contact: Contacts | undefined = await fetchContactById(id);
  if (contact) {
    preTenancyData.value.contactId = contact.id;
  }
};
const isMobile = computed(() => {
  return screenSize.value < 768;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((showModal).value = $event)),
      title: "Pre-Tenancy Setup",
      showCloseConfirmationPrompt: displayCloseConfirmationPrompt.value,
      height: isMobile.value ? 'auto' : '650px',
      width: _unref(ModalWidth).Medium,
      onCancelPromptDenied: cancelPromptDenied,
      onCancelConfirmationModal: keepEnteredInformation,
      onModalClosed: modalClosed
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(DxTabPanel), {
          "scroll-by-content": true,
          "show-nav-buttons": true,
          "swipe-enabled": false,
          selectedIndex: selectedTab.value,
          "onUpdate:selectedIndex": _cache[22] || (_cache[22] = ($event: any) => ((selectedTab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), { title: "Main Details" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(PropertyLookup, {
                      modelValue: preTenancyData.value.propertyId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((preTenancyData.value.propertyId) = $event)),
                      label: "Property",
                      required: _unref(TenanciesValidation).PropertyID.isRequired,
                      defaultCategory: _unref(PropertyCategory).ToLet,
                      onAddressSelected: handlePropertySelect,
                      displayNavigateIcon: false,
                      displayPeek: true
                    }, null, 8, ["modelValue", "required", "defaultCategory"]),
                    _createVNode(ContactLookup, {
                      modelValue: preTenancyData.value.contactId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((preTenancyData.value.contactId) = $event)),
                      label: "Tenant",
                      isRequired: tenantFieldRequired.value,
                      "read-only": false,
                      onContactSelected: handleContactSelect,
                      "find-type-restriction": _unref(ContactFindTypeRestriction).Tenants,
                      "restricted-field-name": 'isRestricted',
                      showNewContactButton: true,
                      onOpenNewContactModal: openNewContactModal,
                      showNavigateContactIcon: false,
                      displayPeek: true
                    }, null, 8, ["modelValue", "isRequired", "find-type-restriction"]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(AcquaintDateBox, {
                        label: "Start Date",
                        modelValue: preTenancyData.value.startDate,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((preTenancyData.value.startDate) = $event)),
                        readOnly: false,
                        fieldValidation: _unref(TenanciesValidation).StartDate,
                        requiredInput: false,
                        onValueSelected: handleStartDate,
                        validationGroup: "PreTenancyValidationGroup"
                      }, null, 8, ["modelValue", "fieldValidation"]),
                      _createVNode(NumberDropdown, {
                        fieldValidation: _unref(TenanciesValidation).Interval,
                        modelValue: preTenancyData.value.duration,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((preTenancyData.value.duration) = $event)),
                          handleEndDate
                        ],
                        itemNumber: 240,
                        allowZeroValue: false,
                        label: "Duration",
                        validationGroup: "PreTenancyValidationGroup",
                        width: _unref(FieldSize).Full
                      }, null, 8, ["fieldValidation", "modelValue", "width"]),
                      _createVNode(SystemCodeSingleSelect, {
                        "code-type": _unref(CodeType).TenancyInterval,
                        fieldValidation: _unref(TenanciesValidation).Interval,
                        label: "Interval",
                        modelValue: preTenancyData.value.interval,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((preTenancyData.value.interval) = $event)),
                        onValueChanged: handleInterval
                      }, null, 8, ["code-type", "fieldValidation", "modelValue"]),
                      _createVNode(AcquaintDateBox, {
                        label: "End Date",
                        modelValue: preTenancyData.value.endDate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((preTenancyData.value.endDate) = $event)),
                        readOnly: true,
                        fieldValidation: _unref(TenanciesValidation).EndDate,
                        requiredInput: false,
                        validationGroup: "PreTenancyValidationGroup"
                      }, null, 8, ["modelValue", "fieldValidation"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(CurrencyInput, {
                        modelValue: preTenancyData.value.rent,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => ((preTenancyData.value.rent) = $event)),
                          handleRentChanged
                        ],
                        label: "Rent",
                        minValue: 0,
                        maxValue: 99999999,
                        fieldValidation: _unref(TenanciesValidation).Amount,
                        validationGroup: "PreTenancyValidationGroup"
                      }, null, 8, ["modelValue", "fieldValidation"]),
                      _createVNode(SingleSelect, {
                        label: "Payment Day",
                        modelValue: preTenancyData.value.rentPaymentDay,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((preTenancyData.value.rentPaymentDay) = $event)),
                        "data-source": _unref(TenancyHelper).populateDays()
                      }, null, 8, ["modelValue", "data-source"]),
                      _createVNode(SystemCodeSingleSelect, {
                        "code-type": _unref(CodeType).PaymentFrequency,
                        fieldValidation: _unref(TenanciesValidation).PaymentFrequency,
                        label: "Payment Frequency",
                        modelValue: preTenancyData.value.rentPaymentFrequency,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((preTenancyData.value.rentPaymentFrequency) = $event)),
                        onValueChanged: handlePaymentFrequencyChanged
                      }, null, 8, ["code-type", "fieldValidation", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(CurrencyInput, {
                        modelValue: preTenancyData.value.deposit,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((preTenancyData.value.deposit) = $event)),
                        label: "Deposit",
                        minValue: 0,
                        maxValue: 99999999,
                        fieldValidation: _unref(TenanciesValidation).Deposit,
                        validationGroup: "PreTenancyValidationGroup"
                      }, null, 8, ["modelValue", "fieldValidation"]),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(depositInfo.value), 1),
                      _createVNode(SystemCodeSingleSelect, {
                        "code-type": _unref(CodeType).DepositHeld,
                        fieldValidation: _unref(TenanciesValidation).DepositHeldBy,
                        label: "Deposit Held By",
                        modelValue: preTenancyData.value.depositHeldBy,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((preTenancyData.value.depositHeldBy) = $event))
                      }, null, 8, ["code-type", "fieldValidation", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(CurrencyInput, {
                        modelValue: preTenancyData.value.holdingDeposit,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((preTenancyData.value.holdingDeposit) = $event)),
                        label: "Holding Deposit",
                        minValue: 0,
                        maxValue: 99999999,
                        fieldValidation: _unref(TenanciesValidation).Deposit,
                        validationGroup: "PreTenancyValidationGroup"
                      }, null, 8, ["modelValue", "fieldValidation"]),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(maxHoldingDepositInfo.value), 1),
                      _createVNode(SystemCodeSingleSelect, {
                        "code-type": _unref(CodeType).DeductHoldingDepositFrom,
                        fieldValidation: _unref(TenanciesValidation).Deposit,
                        label: "Deduct Holding Deposit From",
                        modelValue: preTenancyData.value.deductHoldingDepositFrom,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((preTenancyData.value.deductHoldingDepositFrom) = $event))
                      }, null, 8, ["code-type", "fieldValidation", "modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(CurrencyInput, {
                        modelValue: preTenancyData.value.upfrontRent,
                        "onUpdate:modelValue": [
                          _cache[13] || (_cache[13] = ($event: any) => ((preTenancyData.value.upfrontRent) = $event)),
                          handleUpfrontRent
                        ],
                        label: "Upfront Rent Received",
                        minValue: 0,
                        maxValue: 99999999,
                        fieldValidation: _unref(TenanciesValidation).Amount,
                        validationGroup: "PreTenancyValidationGroup"
                      }, null, 8, ["modelValue", "fieldValidation"]),
                      _createVNode(SingleSelect, {
                        label: "Payment Method",
                        modelValue: preTenancyData.value.paymentReceivedMethod,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((preTenancyData.value.paymentReceivedMethod) = $event)),
                        "data-source": _unref(paymentMethods)
                      }, null, 8, ["modelValue", "data-source"]),
                      _createVNode(LookupSingleSelect, {
                        fieldValidation: _unref(BankAccountsValidation).AccountNumber,
                        label: "Bank Accounts",
                        modelValue: preTenancyData.value.bankAccountId,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((preTenancyData.value.bankAccountId) = $event)),
                        readOnly: false,
                        "lookup-source": _unref(LookupTableSource).BankAccounts
                      }, null, 8, ["fieldValidation", "modelValue", "lookup-source"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(CurrencyInfoBox, {
                        label: "Total Due",
                        value: totalDueAmount.value,
                        boldText: true
                      }, null, 8, ["value"]),
                      _createVNode(SwitchToggle, {
                        class: "toggle",
                        label: "Receive Payment Now?",
                        labelWidth: "9.5rem",
                        modelValue: preTenancyData.value.receivingPayment,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((preTenancyData.value.receivingPayment) = $event)),
                        "read-only": isUpfrontRentReceived.value
                      }, null, 8, ["modelValue", "read-only"]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(AcquaintDateBox, {
                          label: "Received Date",
                          modelValue: preTenancyData.value.paymentReceivedDate,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((preTenancyData.value.paymentReceivedDate) = $event)),
                          readOnly: false,
                          fieldValidation: _unref(TenanciesValidation).StartDate,
                          requiredInput: false,
                          validationGroup: "PreTenancyValidationGroup"
                        }, null, 8, ["modelValue", "fieldValidation"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(ContactLookup, {
                          modelValue: preTenancyData.value.paymentReceivedByUserId,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((preTenancyData.value.paymentReceivedByUserId) = $event)),
                          fieldValidation: _unref(TenanciesValidation).UserID,
                          label: "Received By",
                          "read-only": false,
                          showNavigateContactIcon: false
                        }, null, 8, ["modelValue", "fieldValidation"])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Additional Fees" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(SetupFeeGrid, {
                    totalAmount: setupFeeTotal.value,
                    "onUpdate:totalAmount": _cache[19] || (_cache[19] = ($event: any) => ((setupFeeTotal).value = $event)),
                    setupFees: setupFees.value,
                    "onUpdate:setupFees": _cache[20] || (_cache[20] = ($event: any) => ((setupFees).value = $event)),
                    forceUpdateValue: autoNumber.value,
                    passedSetupFeeGridItems: setupFeeGridItems.value,
                    gridHeight: '45vh'
                  }, null, 8, ["totalAmount", "setupFees", "forceUpdateValue", "passedSetupFeeGridItems"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "More Details" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(AcquaintTextArea, {
                    fieldValidation: _unref(TenanciesValidation).Notes,
                    label: "Offer Notes",
                    modelValue: preTenancyData.value.notes,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((preTenancyData.value.notes) = $event)),
                    validationGroup: "PreTenancyValidationGroup",
                    height: '45vh'
                  }, null, 8, ["fieldValidation", "modelValue"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Tenants & Guarantors" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(TenantsGuarantors, {
                    forceUpdateValue: autoNumber.value,
                    tenantId: preTenancyData.value.contactId
                  }, null, 8, ["forceUpdateValue", "tenantId"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Permitted Occupiers" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(PermittedOccupiers, {
                    forceUpdateValue: autoNumber.value,
                    initialPermittedFormData: initialPermittedFormData.value,
                    onInitialOpened: onPermittedInitialOpened,
                    onUpdateContactIds: onPermittedUpdateContactIds
                  }, null, 8, ["forceUpdateValue", "initialPermittedFormData"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["selectedIndex"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Save',
          disabled: !enableButttonStates.value,
          onClick: (e) => {
            saveDetails(e);
          },
          validationGroup: 'PreTenancyValidationGroup',
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            cancelClick();
          },
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "showCloseConfirmationPrompt", "height", "width"]),
    _createVNode(ContactModal, {
      modelValue: displayNewContactModal.value,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((displayNewContactModal).value = $event)),
      onContactCreated: contactCreated
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})